export default __webpack_public_path__ + "static/media/books.c31f2315.jpg";